import 'web-animations-js';
import Misc from '../misc';
import { headerMenuAnimation } from './animations';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export class NavDefault {

  constructor() {

    this.mobileMenuLayout = parseInt(Misc.getMediaQueries().mobileMenuLayout);
    this.triggerMenu = document.querySelector('.site-header__menu-trigger a');

    if (!this.triggerMenu) {
      return false;
    }

    this.headerWrapper = document.querySelector('.site-header');
    this.menuWrapper = document.querySelector('.site-header__menu-wrapper');

    this.toggleMenu = this.toggleMenu.bind(this);
    this.handleOnResize = this.handleOnResize.bind(this);
    this.handleOnScroll = this.handleOnScroll.bind(this);
    this.handleSubMenu = this.handleSubMenu.bind(this);

    // Init if mobilemenurea
    if (Misc.getViewport().width < this.mobileMenuLayout) {
      window.bodyLayout = 'mobilemenu-layout';
      this.triggerMenu.addEventListener('click', this.toggleMenu);
    }

    [].slice.call(document.querySelectorAll('.menu-item-has-children')).forEach(item => {
      item.firstElementChild.addEventListener('click', this.handleSubMenu)
    })

    // Handle on Resize
    window.addEventListener('resize', this.handleOnResize);
    window.addEventListener('scroll', this.handleOnScroll);

  }

  toggleMenu(event) {
    event.preventDefault();
    const menuNavHeight = this.getMenuNavHeight();

    if (!this.triggerMenu.classList.contains('active')) {
      this.openMenu();
    } else {
      this.closeMenu();
    }
  }

  getMenuNavHeight() {
    let menu = this.menuWrapper.querySelector('.site-header__menu').getBoundingClientRect().height;
    let menuAside = this.menuWrapper.querySelector('.site-header__menu-aside').getBoundingClientRect().height;
    return parseInt(menu + menuAside + 1);
  }

  getMenuWrapperHeight() {
    return parseInt(this.headerWrapper.querySelector('.site-header__main').getBoundingClientRect().height);
  }

  openMenu() {
    let menuNavHeight = this.getMenuNavHeight();
    const menuWrapperHeight = this.getMenuWrapperHeight();
    const viewportHeight = Misc.getViewport().height;

    this.headerWrapper.style.overflow = 'scroll';
    this.headerWrapper.style.height = `${viewportHeight}px`;
    this.triggerMenu.classList.add('active');
    this.menuWrapper.style.height = `${this.getMenuNavHeight()}px`;

    disableBodyScroll(this.headerWrapper);

    if (document.querySelector('#wpadminbar')) {
      menuNavHeight += document.querySelector('#wpadminbar').getBoundingClientRect().height;
    }

    const headerAnimation = this.headerWrapper.animate({
      height: [`${menuWrapperHeight}px`, `${viewportHeight}px`]
    }, {
      duration: 200,
      fill: 'forwards',
    });

    headerAnimation.onfinish = () => {
      this.headerWrapper.style.removeProperty('background-color');
      this.headerWrapper.style.removeProperty('opacity');
      headerMenuAnimation.slideDown({
        element: this.menuWrapper,
      });
      headerAnimation.cancel();
    }

  }

  closeMenu() {
    const menuNavHeight = this.getMenuNavHeight();
    const menuWrapperHeight = this.getMenuWrapperHeight();
    const viewportHeight = Misc.getViewport().height;

    const menuWrapperAnimation = this.menuWrapper.animate({
      opacity: [1, 0]
    }, {
      duration: 200,
      fill: 'forwards'
    });

    menuWrapperAnimation.onfinish = () => {
      this.menuWrapper.removeAttribute('style');
    }

    const headerAnimation = this.headerWrapper.animate({
      height: [`${menuWrapperHeight}px`, `${menuWrapperHeight - menuNavHeight}px`],
      
    }, {
      duration: 200,
      fill: 'forwards',
    });

    headerAnimation.onfinish = () => {
      this.headerWrapper.style.removeProperty('height');
      this.headerWrapper.style.removeProperty('overflow');
      this.triggerMenu.classList.remove('active');
      headerAnimation.cancel();
      enableBodyScroll(this.headerWrapper);
    }

  }

  handleOnResize() {
    if (Misc.getViewport().width > this.mobileMenuLayout && window.bodyLayout === 'nondesktop-layout') {
      window.bodyLayout = null;
      this.triggerMenu.removeEventListener('click', this.toggleMenu);
      this.triggerMenu.classList.remove('active');
      this.headerWrapper.removeAttribute('style');
      this.menuWrapper.removeAttribute('style');

      clearAllBodyScrollLocks();
    }

    if (Misc.getViewport().width < this.mobileMenuLayout && window.bodyLayout !== 'nondesktop-layout') {
      window.bodyLayout = 'nondesktop-layout';
      this.triggerMenu.addEventListener('click', this.toggleMenu);
    }
  }

  handleOnScroll(event) {

    const scrollTop = window.scrollY;

    if (!this.headerWrapper.classList.contains('header-wrapper--absolute')) {
      return false;
    }

    if (Misc.getViewport().width < this.mobileMenuLayout) {
      return this.headerWrapper.classList.remove('header-wrapper--fixed')
    }

    if (scrollTop > 0) {
      this.headerWrapper.classList.add('header-wrapper--fixed')
    } else {
      this.headerWrapper.classList.remove('header-wrapper--fixed')
    }
  }

  handleSubMenu(event) {
    
    if (Misc.getViewport().width > this.mobileMenuLayout) {
      return false;
    }

    const subMenu = event.currentTarget.parentElement.querySelector('.sub-menu');
    const subMenuHeight = this.getSubMenuHeight(subMenu);
    
    if (!event.currentTarget.classList.contains('active') ) {
      this.openSubMenu(event, subMenu, subMenuHeight);
    } else {
      this.closeSubMenu(event, subMenu, subMenuHeight);
    }

  }

  openSubMenu(event, subMenu, subMenuHeight) {

    const hasSubMenuClass = event.currentTarget.closest('.sub-menu');

    headerMenuAnimation.slideDown({
      element: subMenu,
      height: subMenuHeight,
      onAnimationBefore: () => {
        this.menuWrapper.style.height = `${this.menuWrapper.getBoundingClientRect().height + subMenuHeight}px`;
        event.currentTarget.classList.add('active');
        if (hasSubMenuClass) {
          hasSubMenuClass.style.height = `${hasSubMenuClass.getBoundingClientRect().height + subMenuHeight}px`;
        }
      }
    });
  }

  closeSubMenu(event, subMenu, subMenuHeight) {

    const hasSubMenuClass = event.currentTarget.closest('.sub-menu');

    headerMenuAnimation.slideUp({
      element: subMenu,
      height: subMenuHeight,
      onAnimationBefore: () => {
        event.currentTarget.classList.remove('active');
        if (hasSubMenuClass) {
          // hasSubMenuClass.style.transition = 'height ease 0ms';
          hasSubMenuClass.style.height = `${hasSubMenuClass.getBoundingClientRect().height - subMenuHeight}px`;
        }
      },
      onAnimationFinish: () => {
        this.menuWrapper.style.height = `${this.menuWrapper.getBoundingClientRect().height - subMenuHeight}px`;
      }
    });
  }

  getSubMenuHeight(subMenu) {
    let totalHeight = 0;
    [].slice.call(subMenu.querySelectorAll('& > li')).forEach( item => {
      totalHeight += item.getBoundingClientRect().height;
    })
    return totalHeight;
  }

}